import { render, staticRenderFns } from "./DasAccessories.vue?vue&type=template&id=b8746aae"
import script from "./DasAccessories.vue?vue&type=script&lang=js"
export * from "./DasAccessories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports